import { createGenericFormSlice, SliceState } from "./genericFormSlice";

export interface sendHostMessage {
  message: string | undefined;
}

const formSlice = createGenericFormSlice({
  name: "sendHostMessage",
  initialState: {} as SliceState<sendHostMessage>,
  reducers: {},
});

export const { reset, initialize, updateField } = formSlice.actions;
const sendHostMessageFormReducer = formSlice.reducer;
export default sendHostMessageFormReducer;
